
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/association",
      function () {
        return require("private-next-pages/association/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/association"])
      });
    }
  